
export default {
  default() {
    return {}
  },

  forCreate(data) {
    return {
      ...data
    };
  },

  forUpdate(data) {
    return {
      ...data
    };
  }
};



// WEBPACK FOOTER //
// ./src/entities/category/category-model.js